import { render, staticRenderFns } from "./ModelMakeSame.vue?vue&type=template&id=830c1174&"
import script from "./ModelMakeSame.vue?vue&type=script&lang=js&"
export * from "./ModelMakeSame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports